<template>
  <router-view />
</template>

<script>

export default {
  name: 'YardWrapper'
}
</script>
